import React from 'react';

export default function LoadingSpinner({ size = 'md', label }) {
  const sizes = { sm: 'h-4 w-4 border-2', md: 'h-6 w-6 border-2', lg: 'h-10 w-10 border-[3px]' };
  return (
    <div className="flex items-center justify-center gap-3 py-6 text-ink-muted">
      <span
        className={`inline-block animate-spin rounded-full border-primary border-t-transparent ${sizes[size]}`}
      />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
